var ModalStyles = Class.create({
    getModalStyles: function() {
        var modalStyles = {
            overlay: {
                position: 'fixed',
                top: 0,
                left: 0,
                right: 0,
                bottom: 0,
                backgroundColor: 'rgba(0, 0, 0, 0.15)'
            },
            content : {
                top                 : '50%',
                left                : '50%',
                right               : 'auto',
                bottom              : 'auto',
                transform           : 'translate(-50%, -50%)',
                width               : '600px',
                border              : 'none',
                padding             : '10px 30px',
                borderRadius        : '10px',
            }
        }

        return modalStyles;
    }
});

export let modalStyles = new ModalStyles();


// WEBPACK FOOTER //
// app/core/controllers/ModalStyles.js